import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { Configuration } from 'config/config';
import { BreadcrumbService } from '../breadcrumb.service';
import { ICompany } from '../shared/Domains/company';
import { IUser } from '../shared/Domains/IUser';
import { IMember } from '../shared/Domains/member';
import { IMemberContact } from '../shared/Domains/memberContact';
import { IPackageBuider } from '../shared/Domains/packageBuilder';
import { IRole } from '../shared/Domains/role';

@Component({
  selector: 'app-lock-list',
  templateUrl: './lock-list.component.html',
  styleUrls: ['./lock-list.component.css']
})
export class LockListComponent implements OnInit {
  @ViewChild("searchProduct", { static: false }) searchProductInput: ElementRef;
  tabIndex: number = 0;
  minQuantity: number;
  user: IUser;
  loading: boolean;
  imgPreview: boolean = false;
  imgPreviewImg: any;
  sourceProducts: any[];
  first: number = 0;
  company: ICompany;
  role: IRole;
  member: IMember;
  members: any[];
  sourceMembers: any[];
  sortedmembers = [];
  isMemberLOcked: boolean = false;
  lang = "en";

  en = {
    "lockedMembersLabel": "Locked Members",
    "searchByMembeNameLabel": "Search By Member Name",
    "searchByTagNumberLabel": "Search By Tag Number",
    "tagNumberLabel": "Tag Number",//Duplicate
    "profileLabel": "Profile",//Duplicate
    "nameLabel": "Name",//Duplicate
    "mobile#Label": "Mobile #",//Duplicate
    "statusLabel": "Status",//Duplicate
    "actionLabel": "Action",//Duplicate
    "noRecordFoundLabel": "No Record Found",
    "searchHerePlaceholderLabel": "Search here!",//Duplicate Not working
    "clearTooltipLabel": "Clear",//Duplicate
    "viewDetailsTooltipLabel": "View Details",


  }
  ar = {
    "lockedMembersLabel": "الأعضاء المقفلين",
    "searchByMembeNameLabel": "البحث حسب اسم العضو",
    "searchByTagNumberLabel": "البحث حسب رقم العلامة",
    "tagNumberLabel": "رقم العلامة",//Duplicate
    "profileLabel": "حساب تعريفي",//Duplicate
    "nameLabel": "اسم",//Duplicate
    "mobile#Label": "متحرك #",//Duplicate
    "statusLabel": "حالة",//Duplicate
    "actionLabel": "فعل",//Duplicate
    "noRecordFoundLabel": "لا يوجد سجلات",
    "searchHerePlaceholderLabel": "ابحث هنا!",//Duplicate Not working
    "clearTooltipLabel": "واضح",//Duplicate
    "viewDetailsTooltipLabel": "عرض التفاصيل",
  }
  setLabel(label) {
    if (this.lang === "en") {
      return this.en[label];

    }
    else if (this.lang === "ar") {
      return this.ar[label];

    }

  }
  constructor(
    private messageService: MessageService,
    private breadcrumbService: BreadcrumbService,
    private route: Router,
    public config: Configuration,
    private appServiceManager: AppServiceManager,
    private confirmationService: ConfirmationService,
    private loader: NgxSpinnerService,

  ) {
    this.breadcrumbService.setItems([
      { label: 'Locked List' }
    ]);
  }

  ngOnInit(): void {
    this.member = new IMember();
    this.member.contactDetail = new IMemberContact();
    this.user = AuthService.getLoggedInUser();
    this.role = AuthService.getLoggedInRole();
    this.company = new ICompany();
    this.members = [];
    this.sourceMembers = [];
    this.sortedmembers = [];
    this.getCompany();
    this.getMembers();

  }

  getCompany() {
    this.appServiceManager.get("companies/current").subscribe(
      (res) => {
        if (res) {
          this.company = res;
        } else {
          this.company = new ICompany();
          this.messageService.clear();
          this.messageService.add({
            severity: "info",
            summary: "Info Message",
            detail: "Something Went Wrong",
          });
        }
      },
      (error) => {
        this.company = new ICompany();
        this.messageService.clear();
        this.messageService.add({
          severity: "error",
          summary: "Error Message",
          detail: error,
        });
      }
    );
  }

  getMembers() {
    this.members = [];
    this.sourceMembers = [];
    this.sortedmembers = [];
    this.loading = true;
    this.loader.show();
    this.appServiceManager.get('branches/' + this.user.branch + '/customers/actions/short').subscribe((res: IMember[]) => {
      if (res.length > 0) {

        this.sortmembers(res);
        this.loading = false;
        this.loader.hide();
      } else {
        this.loading = false;
        this.loader.hide();
        this.members = [];
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      }
    },
      (error) => {
        this.loader.hide();
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error.error.message, });
      });
  }

  sortmembers(members) {
    for (var i = 0; i < members.length; i++) {
      if (members[i].isDelete == false && members[i].freezeDetail.isFreeze == false) {
        this.sortedmembers.push(members[i])
      }
    }
    this.sortedmembers.sort(function (a, b) {
      if (a.name.substring(0, 1).toLowerCase() < b.name.substring(0, 1).toLowerCase()) {
        return -1;
      }
      else if (a.name.substring(0, 1).toLowerCase() > b.name.substring(0, 1).toLowerCase()) {
        return 1;
      }
      return 0;
    });
    for (var i = 0; i < members.length; i++) {
      if (members[i].isDelete == true || members[i].freezeDetail.isFreeze == true) {
        this.sortedmembers.push(members[i])
      }
    }
    this.members = this.sortedmembers.filter(x => x.isLocked);
    this.members = this.members.sort(
      (a, b) => {
        return (
          <any>new Date(b.modifiedDate) - <any>new Date(a.modifiedDate)
        );
      }
    );
    this.sourceMembers = this.sortedmembers.filter(x => x.isLocked);
    this.sourceMembers = this.sourceMembers.sort(
      (a, b) => {
        return (
          <any>new Date(b.modifiedDate) - <any>new Date(a.modifiedDate)
        );
      }
    );
    this.members = [...this.members];
    this.sourceMembers = [...this.sourceMembers]
  }


  openPhoto(imgUri: string, gender : any, e: Event) {
    e.stopPropagation();
    this.imgPreview = true;

    // Check if imgUri is empty or null
    if (!imgUri) {
      // Handle the case when imgUri is empty or null
      if(gender == 'F')
      this.imgPreviewImg = 'avatarGirlImage.png';

    } else {

      const isGirlAvatar = imgUri === 'avatarGirlImage.png';

      if (isGirlAvatar) {
        this.imgPreviewImg = 'avatarGirlImage.png';
      } else {
        // Handle other images
        this.imgPreviewImg = imgUri;
      }
    }
  }


  closePhotoPreview() {
    this.imgPreview = false;
    this.imgPreviewImg = "";
  }

  viewMember(member) {
    this.route.navigateByUrl('members/member/' + member._id)
  }

  searchLocal(value, type) {
    let matchedName = [];
    let matchedTagNumber = [];
    let matchedContact = [];
    let matchedEmail = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "") {
        this.members = Object.assign([], this.sourceMembers);
      }
      if (!value) {
        this.members = Object.assign([], this.sourceMembers);
      }
      if (value != "") {
        if (type === "tagNumber") {
          matchedContact = Object.assign([], this.sourceMembers).filter(
            cust => cust.tagNumber ? cust.tagNumber.indexOf(value) > -1 : null);
        } else if (type === "contact") {
          matchedTagNumber = Object.assign([], this.sourceMembers).filter(
            cust => cust.contactDetail.contact ? cust.contactDetail.contact.indexOf(value) > -1 : null);
        } else {
          matchedName = Object.assign([], this.sourceMembers).filter(
            cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);

          matchedEmail = Object.assign([], this.sourceMembers).filter(
            cust => cust.email ? cust.email.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
        }
        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        const source = matchedName.concat(matchedTagNumber, matchedContact, matchedEmail);
        this.members = source.filter(distinct);

        if (this.members.length === 0) {
          this.members = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.first = 0;
          if (this.members.length === 1) {
            this.first = 0;
          }
          this.members = [...this.members];
          this.members.sort(this.compare);
        }
      }
    } else {
      this.members = Object.assign([], this.sourceMembers);
      this.members = [...this.members];
    }
  }

  compare(a, b) {
    const tagA = parseInt(a.tagNumber);
    const tagB = parseInt(b.tagNumber);
    let comparison = 0;
    if (tagA > tagB) {
      comparison = 1;
    } else if (tagA < tagB) {
      comparison = -1;
    }
    return comparison;
  }

  clear() {
    this.member = new IMember();
    this.member.contactDetail = new IMemberContact();
    this.searchLocal("", "");
    this.first = 0;
  }

  onPageChange(event) {
    this.first = event.first;
  }


  handleSwitchChange(member, e) {
    let data = {
      company: this.user.company,
      branch: this.user.branch,
      isLocked: member.isLocked,
      modifiedBy: this.user._id
    }
    this.appServiceManager.put("customers/changeLockedStatus/" + member._id, data)
      .subscribe((res: any) => {
        if (res) {
          member = res.customer;
          e.checked = res.customer.isLocked;
          this.messageService.clear();
          this.messageService.add({
            severity: "success",
            summary: "Success Message",
            detail: "Status Successfully changed",
          });
        } else {
          this.messageService.clear();
          this.messageService.add({
            severity: "info",
            summary: "Info Message",
            detail: "Something Went Wrong",
          });
        }
      },
        (error) => {
          this.messageService.clear();
          this.messageService.add({
            severity: "error",
            summary: "Error Message",
            detail: error,
          });
        }
      );
  }



}
